(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.TalentSolutions",
            {
                url: "/TalentSolutions",
                component: "talentsolutions",
                PageTitle: "Talent Solutions",
                resolve: {
                    states: ["states", function (states) {
                        return states;
                    }]
                }
            });
        }
    ]);

    app.component("talentsolutions",
    {
        templateUrl: "App/Resources/TalentSolutions/TalentSolutions.html",
        controller: talentSolutionsCtrl,
        bindings: {
            states: "<"
        }
    });

    talentSolutionsCtrl.$inject = ["$mdDialog", "$http", "$timeout", "$filter", "eligibilityFormDialog", "surveys", "eligibilityFormApi", "amplitudeService"];

    function talentSolutionsCtrl($mdDialog, $http, $timeout, $filter, eligibilityFormDialog, surveys, eligibilityFormApi, amplitudeService) {

        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

        surveys.then(function (s) {          
            eligibilityFormApi.isEnrolled(s.figTalentSolutionsId).then(function (response) {
                $ctrl.submitted = response;
            });
        });       

        /*  Open the Enrollment Form  */
        $ctrl.openDialog = function (event) {
            surveys.then(function (s) {
                eligibilityFormDialog.open(event, s.figTalentSolutionsId).then(function (obj) {
                    ng.extend($ctrl, obj);
                });
            });
        }      
    }  
})(window.app, window.angular); // jshint ignore:line